module.exports = __webpack_public_path__ + "img/card-icon.606f7911.svg";